import React, { useState } from 'react';
import ArticleAccess from '@fuww/library/src/Login/ArticleAccess';
import Divider from '@fuww/library/src/Login/Divider';
import { useIntl } from 'react-intl';
import EmailAccess from './EmailAccess';
import LoginWithProviderForm from './LoginWithProviderForm';
import messages from '../../lib/messages.mjs';
import { CaptchaProvider } from '../Captcha';

const ArticleAccessForm = () => {
  const intl = useIntl();
  const [
    verifyEmailMessage, setVerifyEmailMessage,
  ] = useState<string | undefined>();

  return verifyEmailMessage ? (
    <ArticleAccess verifyEmailMessage={verifyEmailMessage} />
  ) : (
    <ArticleAccess
      invitation={
        intl.formatMessage(messages.articleAccessInvitation)
      }
    >
      <CaptchaProvider>
        <EmailAccess
          setVerifyEmailMessage={setVerifyEmailMessage}
        />
      </CaptchaProvider>
      <Divider dividerText="OR" margin="32px 0 0" />
      <LoginWithProviderForm
        provider="google"
      />
      <LoginWithProviderForm
        provider="linkedin"
      />
    </ArticleAccess>
  );
};

ArticleAccessForm.propTypes = {};

ArticleAccessForm.defaultProps = {};

export default ArticleAccessForm;
